export default __webpack_public_path__ + "static/media/apple-logo.2fa0872e.svg";